import { HBBTV_CONST } from '../constants/constants';

const createApplicationManagerObject = () => {
    const obj = document.createElement('object');
    obj.setAttribute('type', HBBTV_CONST.APP_MNGR_TYPE);
    obj.setAttribute('id', HBBTV_CONST.APP_MNGR_ID);
    return obj;
};

const createOipfConfigurationObject = () => {
    const obj = document.createElement('object');
    obj.setAttribute('type', HBBTV_CONST.APP_CONF_TYPE);
    obj.setAttribute('id', HBBTV_CONST.APP_CONF_ID);
    return obj;
};

const createBroadcastVideoObject = () => {
    const obj = document.createElement('object');
    obj.setAttribute('type', HBBTV_CONST.APP_BROADCAST_VIDEO_TYPE);
    obj.setAttribute('id', HBBTV_CONST.APP_BROADCAST_VIDEO_ID);
    return obj;
};

const getUrlParams = url => `${url}?`.split('?')[1]
    .split('&').reduce((params, pair) =>
        ((key, val) => key ? { ...params, [key]: val } : params)
            (...`${pair}=`.split('=').map(decodeURIComponent)), {});


const createRemoteLoggerScriptObject = (search) => {
    const urlParameters = getUrlParams(window.location.href);
    if (urlParameters) {
        let remoteLoggerAddress = urlParameters[search];

        if (remoteLoggerAddress) {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            if (remoteLoggerAddress.indexOf('http') < 0) {
                remoteLoggerAddress = 'http://' + remoteLoggerAddress;
            }
            if (remoteLoggerAddress.substr(-1) !== '/') {
                remoteLoggerAddress += '/';
            }
            script.src = remoteLoggerAddress + 'vorlon.js';

            document.head.appendChild(script);
        }
    }
};

const createOipfCapabilitiesObject = () => {
    const obj = document.createElement('object');
    obj.setAttribute('type', HBBTV_CONST.APP_CAPABILITIES_TYPE);
    obj.setAttribute('id', HBBTV_CONST.APP_CAPABILITIES_ID);
    return obj;
};

const createMediaSynchroniserObject = () => {
    const obj = document.createElement('object');
    obj.setAttribute('type', HBBTV_CONST.MEDIA_SYNCHRONISER_TYPE);
    obj.setAttribute('id', HBBTV_CONST.MEDIA_SYNCHRONISER_ID);
    obj.onError = (lastError, lastErrorSource) => {
        console.log('MediaSynchroniserObject Error:', lastError, lastErrorSource)
    };
    return obj;
};

const createHbbTVCSManager = () => {
    const obj = document.createElement('object');
    obj.setAttribute('type', HBBTV_CONST.HBBTV_CS_MANAGER_TYPE);
    obj.setAttribute('id', HBBTV_CONST.HBBTV_CS_MANAGER_ID);
    return obj;
};

const createDRMObject = () => {
    const obj = document.createElement('object');
    obj.setAttribute('type', HBBTV_CONST.APP_DRM_TYPE);
    obj.setAttribute('id', HBBTV_CONST.APP_DRM_ID);
    return obj;
};


const createStyleObject = () => {
    // this method is created because on some Samsung TV setAttribute('style', '...') is not accepted. style is read-only. WTF.
    const style = `
        #${HBBTV_CONST.APP_MNGR_ID} {
            position: absolute; 
            left: 0px; 
            top: 0px; 
            width: 0px; 
            height: 0px;
        }

        #${HBBTV_CONST.APP_DRM_ID} {
            position: absolute; 
            left: 0px; 
            top: 0px; 
            width: 0px; 
            height: 0px;
        }

        #${HBBTV_CONST.APP_CONF_ID} {
            position: absolute; 
            left: 0px; 
            top: 0px; 
            width: 0px; 
            height: 0px;'
        }

        #${HBBTV_CONST.APP_BROADCAST_VIDEO_ID} {
            position: absolute; 
            left: 0px; 
            top: 0px; 
            width: 100%; 
            height: 100%; 
            z-index:-1;
        }

        #${HBBTV_CONST.APP_CAPABILITIES_ID} {
            position: absolute; 
            left: 0px; 
            top: 0px; 
            width: 0px; 
            height: 0px;
        }

        #${HBBTV_CONST.MEDIA_SYNCHRONISER_ID} {
            position: absolute; 
            left: 0px; 
            top: 0px; 
            width: 0px; 
            height: 0px;
        }

        #${HBBTV_CONST.HBBTV_CS_MANAGER_ID} {
            position: absolute; 
            left: 0px; 
            top: 0px; 
            width: 0px; 
            height: 0px;
        }
    `;
    let styleElement = document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    styleElement.appendChild(document.createTextNode(style));
    document.head.appendChild(styleElement);
}

export { createApplicationManagerObject, createRemoteLoggerScriptObject, createOipfConfigurationObject, createBroadcastVideoObject, createStyleObject, createOipfCapabilitiesObject, createMediaSynchroniserObject, createHbbTVCSManager, createDRMObject }